import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Icon } from '@famly/mf_data-display_icon';
import { Text } from '@famly/mf_data-display_text';
import { Stack, createStack } from '@famly/mf_layout_stack';
import translate from 'signin-app/helpers/translate';
import { StyledTextContainer } from 'signin-app/child/check-in/add-pickup-person';
export const StyledStack = styled(createStack({
    boxSizing: 'border-box',
    width: { base: '80px', tabletPortrait: '96px' },
    height: { base: '80px', tabletPortrait: '96px' },
    borderRadius: { base: 5, tabletPortrait: 6 },
    alignItems: 'center',
    justifyContent: 'center',
})) `
    border: 2px dashed ${props => props.theme.mf.colorPalette.n200};
`;
export const GoingHomeWith = ({ child }) => {
    return (_jsx(Stack, { px: { base: 3, tabletPortrait: 6 }, py: { base: 2, tabletPortrait: 3 }, children: _jsxs(Link, { to: `/go-home-with/${child.id}`, children: [_jsx(StyledStack, { children: _jsx(Icon, { name: "child_care", color: "n300", size: 36 }) }), _jsx(StyledTextContainer, { shouldWrap: true, children: _jsx(Text, { variant: "body-small", color: "n400", emphasized: true, children: translate('goingHomeWith') }) })] }) }));
};
